<template>
  <div class="modelReg">
    <div class="modelReg__grid">
      <div class="modelReg__title">
        <h3>{{ $t('modal.auth_modal_state.change_password.title') }}</h3>
      </div>
      <div v-if="loader" class="modelReg__alertLoading"></div>
      <div v-if="errorMessage" class="modelReg__alertError">{{ errorMessage }}</div>
      <div v-if="successMessage" class="modelReg__alertSuccess">{{ successMessage }}</div>

      <UForm class="modelReg__form">
        <UiKitInput
          v-model="form.oldPassword"
          type="password"
          size="lg"
          :placeholder="$t('modal.auth_modal_state.change_password.old_password')"
          :invalid="v$.oldPassword.$error"
          :error-message="v$.oldPassword.$errors?.[0]?.$message"
          @blur="v$.oldPassword.$touch"
        />
        <div class="modelReg__centerEl">
          <UButton
            color="primary"
            variant="link"
            :label="$t('modal.auth_modal_state.login.for_got_your_password')"
            @click="openForgotPassword"
          />
        </div>

        <UiKitInput
          v-model="form.password"
          type="password"
          size="lg"
          :placeholder="$t('modal.auth_modal_state.change_password.create_password')"
          @blur="v$.password.$touch"
        />

      <!-- Визуальная шкала силы пароля -->
      <UiPasswordStrengthMeter :password="form.password" />

      <!-- Требования к паролю -->
      <div class="passwordRequirements">
        <div class="flex gap-1 items-center">
          <IconTheCheck v-if="!v$.password.latinLetterPattern.$invalid"></IconTheCheck>
          <IconTheError v-else></IconTheError>
          <span>{{ $t('form.error_for_input.password.latin_letter_pattern') }}</span>
        </div>
        <div class="flex gap-1 items-center">
          <IconTheCheck
            v-if="!v$.password.mustBeNumber.$invalid && !v$.password.leastOneSpecialCharacter.$invalid"
          ></IconTheCheck>
          <IconTheError v-else></IconTheError>
          <span>{{ $t('form.error_for_input.password.symbol_or_number') }}</span>
        </div>
        <div class="flex gap-1 items-center">
          <IconTheCheck v-if="!v$.password.isCapitalLetter.$invalid"></IconTheCheck>
          <IconTheError v-else></IconTheError>
          <span>{{ $t('form.error_for_input.password.is_capital_letter') }}</span>
        </div>
        <div class="flex gap-1 items-center">
          <IconTheCheck v-if="!v$.password.minLength.$invalid"></IconTheCheck>
          <IconTheError v-else></IconTheError>
          <span>{{ $t('form.error_for_input.password.min_length') }}</span>
        </div>
      </div>

        <UiKitInput
          v-model="form.confirmPassword"
          type="password"
          size="lg"
          :placeholder="$t('modal.auth_modal_state.change_password.repeat_password')"
          :invalid="v$.confirmPassword.$error"
          :error-message="v$.confirmPassword.$errors?.[0]?.$message"
          @blur="v$.confirmPassword.$touch"
        />

        <UiButtonMain
          class="btn"
          size="xl"
          label="Сменить пароль"
          block
          type="submit"
          :disabled="v$.$invalid"
          @click.prevent="sendChangedPassword"
        ></UiButtonMain>
      </UForm>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { useVuelidate } from '@vuelidate/core';
import apiAuth from '~/entities/auth';
import { useFormMessages, useRulesForForm } from '@shared/lib';

const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      oldPassword: '',
      twoFA: '',
      codeFromEmail: '',
    }),
  },
});

// Используем composables для упрощения кода (DRY)
const { openForgotPassword, closeModal } = useAuthModal();

const form = ref({ ...props.userData });

// Используем composable для управления сообщениями (DRY)
const {
  loader,
  errorMessage,
  successMessage,
  startLoading,
  stopLoading,
  handleSuccess,
  handleError,
} = useFormMessages();

const { RulesForFormConfirmPassword, RulesForFormPassword, RulesForFormNewPassword } = useRulesForForm();

const rules = computed(() => {
  return {
    oldPassword: RulesForFormPassword(),
    password: RulesForFormNewPassword(form.value),
    confirmPassword: RulesForFormConfirmPassword(form.value.password),
  };
});

const v$ = useVuelidate(rules, form);
const sendChangedPassword = async () => {
  const params = {
    currentPassword: form.value.oldPassword,
    newPassword: form.value.password,
  };

  v$.value.$validate();

  if (!v$.value.$error) {
    startLoading();

    try {
      const data = await apiAuth.changePassword(params);
      handleSuccess(
        data.message || 'Пароль успешно изменён!',
        () => closeModal(),
      );
    } catch (error) {
      handleError(error);
    } finally {
      stopLoading();
    }
  }
};
</script>

<style scoped lang="scss">
.modelReg__centerEl {
  @apply flex justify-end;
}
</style>


